<template>
  <div class="sova-club-footer">
    <h3 class="sova-club-footer__title" v-html="item.preview"></h3>
    <div v-if="screenWidth >= 768">
      <DefScrollbar class="sova-club-footer__items">
        <div
          v-for="(el, i) in item.images"
          :key="i"
          class="sova-club-footer__item"
          :class="{
            'sova-club-footer__item_active': inChoice(
              el.property.TABLE_NAME,
              el.property.UF_XML_ID,
              i
            ),
          }"
          @click="setChoice(el.property.TABLE_NAME, el.property.UF_XML_ID, i)"
        >
          <span>
            <svg>
              <use xlink:href="#svg-checked"></use>
            </svg>
            {{ el.property.UF_NAME }}
          </span>

          <a href="javascript:void(0);">
            <!--                        <DefImg :result="el" />-->
            <img :src="el.src" :alt="el.alt" :title="el.property.UF_NAME" />
          </a>
        </div>
      </DefScrollbar>
    </div>

    <DefSlider v-else :settings="settings">
      <span
        v-for="(el, i) in item.images"
        class="swiper-slide sova-club-footer__item"
        :class="{
          'sova-club-footer__item_active': inChoice(
            el.property.TABLE_NAME,
            el.property.UF_XML_ID,
            i
          ),
        }"
        @click="setChoice(el.property.TABLE_NAME, el.property.UF_XML_ID, i)"
      >
        <span>
          <svg>
            <use xlink:href="#svg-checked"></use>
          </svg>
          {{ el.property.UF_NAME }}
        </span>
        <img :src="el.src" :alt="el.alt" :title="el.property.UF_NAME" />
      </span>
    </DefSlider>
    <div v-if="result.error" class="sova-club-footer__error">
      <span>{{ result.error }}</span>
    </div>
    <div class="sova-club-footer__buttons">
      <DefButtonSecondary v-if="result.step > 1" @click="changeStep(result.step - 1)">
        {{ messages.prev }}
      </DefButtonSecondary>
      <DefButtonPrimary @click="changeStep(result.step + 1)">
        {{ messages.next }}
      </DefButtonPrimary>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import DefSlider from '@components/Def/DefSlider/DefSlider.vue';
import DefButtonSecondary from '@components/Def/DefButtonSecondary/DefButtonSecondary.vue';
import DefButtonPrimary from '@components/Def/DefButtonPrimary/DefButtonPrimary.vue';
import { useResultsStore } from '@/storePinia/stores/results';
import { useClubStore } from '@/storePinia/stores/club';
import DefScrollbar from '@components/Def/DefScrollbar/DefScrollbar.vue';
import useScreenWidth from '@use/useScreenWidth';

const props = defineProps(['result']);

const resultsStore = useResultsStore();
const clubStore = useClubStore();
const screenWidth = useScreenWidth();

const messages = computed(() => resultsStore.messages?.sovaClub);

const inChoice = computed(() => clubStore.inChoice);
const item = computed(() => clubStore.getItem);

const changeStep = (step) => {
  clubStore.getDataByStep(step);
};
const setChoice = (table, value, i) => {
  clubStore.setChoice({ table, value, i });
};
const settings = {
  slidesPerView: 1.3,
  spaceBetween: 4,
};
</script>

<style lang="scss" scoped>
.sova-club-footer {
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  &__title {
    font-weight: 600;
    font-size: rem(14);
    line-height: 130%;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: var(--color-main);
    margin-bottom: 24px;
    @include point-md {
      font-size: rem(16);
    }
  }

  &__items {
    margin-bottom: 24px;
    overflow-y: auto;
    position: relative;
    //max-height: 370px;
    @include point-md {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-gap: 4px;
    }
  }

  &__item {
    position: relative;

    span {
      display: none;
    }

    &_active {
      background: rgba(0, 0, 0, 0.6);

      span {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: absolute;
        left: 12px;
        right: 12px;
        font-weight: 600;
        font-size: rem(14);
        line-height: 100%;
        color: #ffffff;
        top: 50%;
        transform: translate(0, -50%);

        svg {
          display: inline-block;
          width: 18px;
          height: 13px;
          fill: #ffffff;
          margin: 14px 0;
        }
      }

      img {
        opacity: 0.2;
      }
    }
  }

  &__buttons {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-column-gap: 4px;
    margin-top: auto;
  }

  &__error {
    margin-bottom: 24px;
    color: red;
  }
}
</style>
